import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#0171FE",
    },
    secondary: red,
    background: {
      default: "#0E1520",
      paper: "#121927",
    },
  },
  shape: {
    borderRadius: 6,
  },
  typography: {
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
    caption: {
      letterSpacing: 0,
      opacity: 0.7,
    },
    fontFamily: '"Poppins", "Helvetica", sans-serif',
    h5: {
      fontWeight: 600,
      letterSpacing: -0.5,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border:"1px solid rgba(255,255,255,.1)"
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          opacity:0.7,
          borderBottom:"1px solid rgba(255,255,255,0.1)"
        },
        body: {
          borderBottom:"1px solid rgba(255,255,255,0.1)"
        },
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& a": {
            textDecoration: "none"
          }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          background: "#141e30"
        }
      }
    }
  }
});

export default theme;
